import { Box, Step, styled, Theme } from "@mui/material";

export const StyledStep = styled(Step)`
  padding: 0;
`;

const getStepIconSize = (theme: Theme, size: "big" | "medium") =>
  `calc(${size === "big" ? theme.wsc.size.l : theme.wsc.size.m} * 2)`;

export const StyledStepIcon = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== "isActive",
})<{
  isActive?: boolean;
  size: "big" | "medium";
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme, size }) => getStepIconSize(theme, size)};
  height: ${({ theme, size }) => getStepIconSize(theme, size)};
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.wsc.palette.primary[300] : theme.wsc.palette.neutral[600]};
  border: ${({ theme, isActive, size }) =>
    `${size === "big" ? 2 : 1}px solid ${
      isActive ? theme.wsc.palette.primary[300] : theme.wsc.palette.neutral[100]
    }`};
  border-radius: ${({ theme }) => theme.wsc.radius.half};
  color: ${({ theme, isActive }) =>
    isActive
      ? theme.wsc.palette.primary.contrastText
      : theme.wsc.palette.neutral[100]};
  ${({ theme, size }) =>
    size === "big"
      ? theme.wsc.typography.header5
      : theme.wsc.typography.body1bold};
`;
